import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import qs from 'qs';

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
  parseQuery: (search) => {
    const parsed = qs.parse(search);
    const result: Record<string, string | string[]> = {};
    for (const [key, value] of Object.entries(parsed)) {
      if (value !== undefined) {
        result[key] = value as string | string[];
      }
    }
    return result;
  },
  stringifyQuery: (query) => qs.stringify(query, { arrayFormat: 'repeat' }),
});

router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    console.error('route:error', error);
    window.location.href = to.fullPath;
  }
});

export default router;
